import { Divider } from '../atoms';
import React from 'react';

const NoUtilizationCard = ({ line, imgsrc, toggleHelp, classes = '' , parent}) => {
  const getContent = () => {
    if (['CSM', 'CSMMaster'].includes(sessionStorage.getItem('role')) && parent !== 'stepathon') {
      return (
        <div>
          <Divider classes='my-6' />
          <p className='mb-0 text-sm italic'>
            To improve the utilization reach out to the marketing team for a customized plan & share it with the HR.
          </p>
        </div>
      );
    } else  {
      if (parent === 'stepathon'){
        return (
          <div>
             <p className='mb-0 mt-2 text-base'>
             To increase the engagement, please create stepathon
             </p>
             <button
               type='button'
               onClick={(e) => toggleHelp(e.target)}
               className='mt-3 inline-flex text-center px-6 py-2 border-none text-base font-semibold rounded text-white bg-blue-600 hover:bg-blue-700 focus:outline-none'
             >
               Create stepathon
             </button>
          </div>
         )
      }
      else{
        return (
          <div>
            <p className='mb-0 mt-2 text-base'>
              To increase the utilization, contact your <span className='font-semibold'>customer success manager</span>
            </p> 
            <button
              type='button'
              onClick={toggleHelp}
              className='mt-8 inline-flex text-center px-6 py-2 border-none text-base font-semibold rounded text-white bg-blue-600 hover:bg-blue-700 focus:outline-none'
            >
              Talk to CSM
            </button>
          </div>
        )
      }
     
    }
  };

  return (
    <div className={'bg-white text-center py-12 px-56 rounded-md h-full text-gray-800 ' + classes}>
      <img src={imgsrc} className='inline-block' height={190} width={190} alt='feature-avatar' />
      { parent !== 'stepathon' ?
        <div>
         <p className='mb-0 mt-8 font-semibold text-2xl text-gray-900'>This feature has not been utilized</p>
         <p className='mb-0 mt-3 text-base'>This section shows the {line}</p>
        </div> 
        :
        <div>
          <p className='mb-0 mt-8 font-semibold text-2xl text-gray-900'>This feature has not been utilized</p>
          <p className='mb-0 mt-3 text-base'>This section shows the stepathon created by you</p>
        </div>

      }
     
      {getContent()}
    </div>
  );
};

export default NoUtilizationCard;
